import * as React from 'react'
import { Button, PageHeader } from '@pushly/aqe/lib/components'
import { classnames } from '@halo/_utils/classnames'
import { observer } from 'mobx-react'
import { DomainList } from '@halo/components/domain-list/domain-list'
import { noop } from '@pushly/aqe/lib/utils/noop'
import { CurrentUserCan } from '@halo/stores/ability.state'
import { AbilityAction } from '@halo/enums/ability-action.enum'
import { SubjectEntity } from '@halo/enums/ability-entity.enum'

export const DOMAINS_ROUTE = '/domains'

@observer
export class Domains extends React.Component<any, any> {
    private domainListRef = React.createRef<DomainList>()

    public render() {
        return (
            <div className={classnames('page', 'domains')}>
                <div className={classnames('page-wrapper')}>
                    <PageHeader
                        title="Domains"
                        onTitleSet={noop}
                        action={
                            <CurrentUserCan do={AbilityAction.CREATE} on={SubjectEntity.DOMAIN}>
                                <Button
                                    type="primary"
                                    onClick={() => this.domainListRef.current?.openNewDomainModal('standard')}
                                >
                                    New Domain
                                </Button>
                            </CurrentUserCan>
                        }
                    />

                    <DomainList ref={this.domainListRef} options={{}} hideCreateButton={true} />
                </div>
            </div>
        )
    }
}
